module.exports = __webpack_public_path__ + "static/MAC-f82a325ec4e35b32a619f6b892573c56.png";